import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { VideoType } from '@/modules/common/types/video';

import { updateVideoResources } from '@/modules/common/helpers/videoCache';

type SearchQuery = {
  query?: Record<string, string | boolean | number>;
  distributionIds?: [VideoType];
  filterIds?: Array<string | number>;
  isAddRequest?: boolean;
};

type State = {
  id: string;
  answer: string;
  totalCount: number;
  playlist: VideoType[];
  playerPropsPassThrow: Record<string, unknown>;
  isLoading: boolean;
  queryRequest: Record<string, unknown>;
};

const initialState: State = {
  id: '',
  answer: '',
  totalCount: 0,
  playlist: [],
  playerPropsPassThrow: {},
  isLoading: false,
  queryRequest: {},
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'searchAi',
  initialState,
  reducers: {
    setInitialState: () => initialState,
    setSearchAiQueryAction: (state, action) => {
      state.queryRequest = action.payload;
    },
    searchAiRequestEventAction: (state) => {
      state.isLoading = true;
    },
    clearSearchAiResultAction: (state) => {
      state.answer = '';
      state.totalCount = 0;
      state.playlist = [];
      state.playerPropsPassThrow = {};
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    searchAiRequestAction: (state, action: PayloadAction<SearchQuery>) => state,
    setSearchAiRequestAction: (state, action) => {
      state.id = action.payload.id;
      state.answer = action.payload.answer;
      state.totalCount = action.payload.totalCount;
      state.playlist = action.payload.playlist;
      state.playerPropsPassThrow = action.payload.playerPropsPassThrow;
      state.isLoading = false;
    },
    autocompleteRequestAction: (state) => state,
    errorSearchAiRequestAction: (state) => {
      state.isLoading = false;
    },
    updateSocialMetricAction: (state, action) => {
      state.playlist.forEach((video) => {
        if (video.mediaid === action.payload.mediaid) {
          Object.entries(action.payload.parameters).forEach(([key, value]) => {
            const item = video.performanceData.parameters.find((item$) => item$.type === key);

            if (item) {
              item.value = value as number;
            }
          });
        }
      });
    },
    updateResourceAction: (state, action) => {
      state.playlist.forEach((video) => {
        updateVideoResources(video, action.payload);
      });
    },
  },
});

export const {
  setInitialState,
  setSearchAiQueryAction,
  clearSearchAiResultAction,
  searchAiRequestEventAction,
  searchAiRequestAction,
  setSearchAiRequestAction,
  errorSearchAiRequestAction,
  updateSocialMetricAction,
  updateResourceAction,
} = slice.actions;
